import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";


import {BasicLayoutComponent} from "./basicLayout.component";
import {BlankLayoutComponent} from "./blankLayout.component";
import {TopNavigationLayoutComponent} from "./topNavigationLayout.component";

import {NavigationComponent} from "../navigation/navigation.component";
import {FooterComponent} from "./partials/footer/footer.component";
import {TopNavbarComponent} from "./partials/topnavbar/topnavbar.component";
import {TopNavigationNavbarComponent} from "./partials/topnavbar/topnavigationnavbar.component";
import {SharedModule} from "../shared.module";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";

@NgModule({
	// The declarations list identifies the application's only component
	declarations: [
		FooterComponent,
		BasicLayoutComponent,
		BlankLayoutComponent,
		NavigationComponent,
		TopNavigationLayoutComponent,
		TopNavbarComponent,
		TopNavigationNavbarComponent
	],
	imports: [
		BrowserModule,
		RouterModule,
		BsDropdownModule.forRoot(),
		SharedModule
	],
	exports: [
		FooterComponent,
		BasicLayoutComponent,
		BlankLayoutComponent,
		NavigationComponent,
		TopNavigationLayoutComponent,
		TopNavbarComponent,
		TopNavigationNavbarComponent
	],
})
export class LayoutsModule {} // end class LayoutsModule
